import React from 'react';
import { Link, useMatch } from 'react-router-dom';
import { styled } from '@mui/material';
import t from '@/utils/translate';

import {
  Header,
  PhoneFilled,
  Telegram2D,
  Button,
  Messages
} from '@/components';

const Contacts = styled('div')(({ theme }) => `
  display: flex;
  justify-content: center;
  text-wrap: nowrap;
  width: 344px;

  & > a {
    display: flex;
    justify-content: center;
    align-items: center;
    min-width: ${theme.spacing(10)};
    height: ${theme.spacing(10)};
    margin-right: ${theme.spacing(2)};
    text-decoration: none;

    &:first-of-type span {
      padding-left: ${theme.spacing(2.5)};
      font-size: ${theme.typography.subtitle1.fontSize}px;
      color: #000;
    }

    &:last-child {
      margin-right: 0;
    }
  }
`);

const Main = styled('main')(`
  position: fixed;
  top: 80px;
  bottom: 0;
  display: flex;
  flex-wrap: nowrap;
  justify-content: start;
  background-color: #f9f9f9;
  width: 100%;
`);

const Aside = styled('aside')(`
  width: 30%;
  min-width: 200px;
  max-width: 420px;
  padding: 20px 24px;
  background-color: #fff;
`);

const Greeting = styled('section')(`
  width: 70%;
  overflow: auto;
  padding: 20px 24px;
`);

const GreetingImg = styled('img')(`
  max-width: 100%;
`);

const LinkToRegistration = () => (
  <Link to="/registration">
    <Button
      variant="contained"
      color="primary"
      style={{ marginLeft: 12 }}
    >{t('action.register')}</Button>
  </Link>
);

const LinkToLogin = () => (
  <Link to="/login">
    <Button
      variant="contained"
      color="primary"
      style={{ marginLeft: 12 }}
    >{t('action.login')}</Button>
  </Link>
);

export default ({ children }: any) => {
  const pageMatch = useMatch('/:page/*');

  return (
    <>
      <Header right-children={
        <Contacts>
          <a href="tel:84993222254">
            <PhoneFilled fontSize="large" color="black" />
            <span>8 (499) 322-22-54</span>
          </a>
      
          <a href="https://t.me/bimdataru" target="_blank" rel="noopener noreferrer">
            <Telegram2D fontSize="large" color="black" />
          </a>
      
          { pageMatch?.params?.page === 'login' && <LinkToRegistration />}
          { pageMatch?.params?.page === 'registration' && <LinkToLogin />}
      
        </Contacts>
      }>
      </Header>

      <Main>
        <Aside>{children}</Aside>
        <Greeting>
          <h1>Создавайте вместе с BIMDATA</h1>
          {/*<!--
          <p>
            Активное внедрение технологий информационного моделирования зданий (BIM) в России,
            открыло возможности для решения проблем строительной отрасли. Двигаясь в направлении
            нового технологического уклада, мы развиваем экосистему по управлению
            инвестиционно-строительным проектам.
          </p>

          <p>
            Основу экосистемы составляют решения в областях микросервисной архитектуры
            (microservice architecture), больших данных (BigData), искуственного интеллекта
            (Artificlal Intelligence), машинного обучения (Machine Learning), трёхмерной
            инженерной графики, включая дополнительную реальность (AR).
          </p>

          <p>
            Мы заинтересованы в достижении высокого профессионального уровня и готовы лидировать в
            своей области.
          </p>
          -->*/}
          <GreetingImg src="/greeting-image.png" alt="" />
        </Greeting>
        <footer>
          <Messages />
        </footer>
      </Main>
    </>
  );
};
